module.exports = __webpack_public_path__ + "static/media/check.0a6b08e0.svg";